import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';

import {
  listConnectionsRpc,
  fetchByMcpServerIdRpc,
  registerRpc,
  deleteRpc,
  deleteSecretRpc,
} from '../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpConnectionRegistryRpc';

import { getMcpServersAvailableToPortalRpc } from '../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpServerRegistryRpc';

export type {
  McpConnection,
  McpConnectionsListResponse,
} from '../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpConnectionRegistryRpc';

export type { McpServer } from '../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpServerRegistryRpc';

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

export const registerConnection = (mcpServerId: number, secretId: string) => {
  return chirpClient.call(registerRpc, {
    request: {
      mcpServerId,
      secretId,
    },
  });
};

export const fetchConnections = () => {
  return chirpClient.call(listConnectionsRpc, {
    request: {},
  });
};

export const deleteConnection = (connectionId: number) => {
  return chirpClient.call(deleteRpc, {
    request: {
      id: connectionId,
    },
  });
};

/**
 * Deletes a secret associated with an MCP server connection.
 */
export const deleteSecret = (
  mcpServerId: number,
  secretId: string
): Promise<{ deleted: boolean }> => {
  return chirpClient.call(deleteSecretRpc, {
    request: {
      mcpServerId,
      secretId,
    },
  });
};

/**
 * Fetches all connections for a specific MCP server.
 */
export const fetchConnectionsForServer = (mcpServerId: number) => {
  return chirpClient.call(fetchByMcpServerIdRpc, {
    request: {
      mcpServerId,
    },
  });
};

/**
 * Fetches all MCP servers available to the current portal.
 */
export const fetchMcpServersAvailableToPortal = (search?: string) => {
  return chirpClient.call(getMcpServersAvailableToPortalRpc, {
    request: {
      search,
    },
  });
};
